import * as React from "react";
type Props = {
  className?: string,
};
function SvgLightning({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-lightning"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6989 3.46213C18.9245 3.8157 18.9055 4.27251 18.6513 4.60612L15.0194 9.37272L17.9114 9.11554C18.3306 9.07826 18.7283 9.30745 18.9063 9.68886C19.0842 10.0703 19.0042 10.5223 18.7063 10.8195L8.79514 20.708C8.48685 21.0156 8.01496 21.0883 7.62839 20.8877C7.24182 20.6872 7.02946 20.2596 7.10334 19.8304L8.14131 13.801L6.08858 13.9835C5.73484 14.015 5.39095 13.8564 5.18511 13.567C4.97927 13.2776 4.94236 12.9008 5.08814 12.5769L8.2768 5.4938C8.40662 5.20542 8.6652 4.99545 8.97408 4.92759L17.6413 3.02335C18.051 2.93335 18.4733 3.10855 18.6989 3.46213ZM9.89419 6.77314L7.6132 11.84L9.25873 11.6937C9.56794 11.6662 9.87238 11.7839 10.0827 12.0122C10.2931 12.2405 10.3855 12.5535 10.3328 12.8594L9.60758 17.0722L15.3409 11.352L12.9388 11.5656C12.5442 11.6007 12.1661 11.3995 11.9747 11.0527C11.7833 10.7058 11.8147 10.2786 12.0548 9.9635L15.4089 5.56152L9.89419 6.77314Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgLightning;
